import React from "react"

import { ShareProjectOverlayView } from "./ShareProjectOverlayView"
import { ShareProjectOverlayModel } from "./hooks/useShareProjectOverlayModel"
import { useShareProjectOverlayViewModel } from "./hooks/useShareProjectOverlayViewModel"

export interface ShareProjectOverlayProps extends ShareProjectOverlayModel {}

export enum ShareProjectOverlayTab {
  LINK = "LINK",
  EMAIL = "EMAIL"
}

export const ShareProjectOverlay = React.memo(
  (props: ShareProjectOverlayProps) => (
    <ShareProjectOverlayView {...useShareProjectOverlayViewModel(props)} />
  )
)
